import { Font, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import RobotoCyrillic from '../assets/fonts/Roboto-Regular.ttf';

Font.register({
  family: 'RobotoCyrillic',
  src: RobotoCyrillic
});

const styles = StyleSheet.create({
  page: { 
    padding: 20, 
    fontSize: 9, 
    fontFamily: 'RobotoCyrillic', 
    backgroundColor: '#ffffff'
  },
  header: {
    marginBottom: 20,
    alignItems: 'center',
    backgroundColor: '#1e40af',
    padding: 15,
    borderRadius: 8
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: 10,
    textAlign: 'center'
  },
  logoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    width: '100%'
  },
  logo: {
    width: 80,
    height: 30,
    backgroundColor: '#3b82f6',
    textAlign: 'center',
    paddingTop: 8,
    fontSize: 8,
    color: '#ffffff',
    borderRadius: 4
  },
  separator: {
    borderBottom: '2px solid #ffffff',
    marginBottom: 15
  },
  section: {
    marginBottom: 15
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: 5,
    textTransform: 'uppercase',
    backgroundColor: '#1e40af',
    padding: 8,
    borderRadius: 4
  },
  sectionSeparator: {
    borderBottom: '1px solid #1e40af',
    marginBottom: 8
  },
  subsection: {
    marginBottom: 10
  },
  subsectionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#1e40af',
    marginBottom: 5,
    backgroundColor: '#dbeafe',
    padding: 6,
    borderRadius: 3
  },
  infoGrid: {
    flexDirection: 'row',
    marginBottom: 3
  },
  infoLabel: {
    width: '40%',
    fontWeight: 'bold',
    color: '#1e40af'
  },
  infoValue: {
    width: '60%',
    color: '#374151'
  },
  progressBox: {
    backgroundColor: '#fef3c7',
    padding: 12,
    borderRadius: 6,
    marginBottom: 10,
    border: '2px solid #f59e0b'
  },
  progressTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#92400e',
    textTransform: 'uppercase',
    marginBottom: 3,
    textAlign: 'center'
  },
  progressValue: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#92400e',
    textAlign: 'center'
  },
  resourcesGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10
  },
  resourceTable: {
    width: '48%'
  },
  table: {
    border: '1px solid #1e40af',
    marginBottom: 8,
    borderRadius: 4
  },
  tableHeader: {
    backgroundColor: '#3b82f6',
    flexDirection: 'row',
    borderBottom: '1px solid #1e40af'
  },
  tableHeaderCell: {
    flex: 1,
    padding: 6,
    fontSize: 8,
    fontWeight: 'bold',
    color: '#ffffff',
    textAlign: 'center'
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #e5e7eb'
  },
  tableRowAlt: {
    flexDirection: 'row',
    borderBottom: '1px solid #e5e7eb',
    backgroundColor: '#f3f4f6'
  },
  tableCell: {
    flex: 1,
    padding: 4,
    fontSize: 8,
    color: '#374151'
  },
  tableCellLarge: {
    flex: 2,
    padding: 4,
    fontSize: 8,
    color: '#374151'
  },
  totalRow: {
    backgroundColor: '#dbeafe',
    fontWeight: 'bold'
  },
  workTable: {
    border: '1px solid #1e40af',
    marginBottom: 10,
    borderRadius: 4
  },
  workTableHeader: {
    backgroundColor: '#3b82f6',
    flexDirection: 'row',
    borderBottom: '1px solid #1e40af'
  },
  workTableHeaderCell: {
    padding: 6,
    fontSize: 8,
    fontWeight: 'bold',
    color: '#ffffff',
    textAlign: 'center'
  },
  workTableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #e5e7eb'
  },
  workTableRowAlt: {
    flexDirection: 'row',
    borderBottom: '1px solid #e5e7eb',
    backgroundColor: '#f3f4f6'
  },
  workTableCell: {
    padding: 4,
    fontSize: 8,
    color: '#374151'
  },
  locationCell: {
    width: '15%',
    padding: 4,
    fontSize: 8,
    color: '#374151'
  },
  activityCell: {
    width: '25%',
    padding: 4,
    fontSize: 8,
    color: '#374151'
  },
  unitCell: {
    width: '8%',
    padding: 4,
    fontSize: 8,
    color: '#374151',
    textAlign: 'center'
  },
  quantityCell: {
    width: '10%',
    padding: 4,
    fontSize: 8,
    color: '#374151',
    textAlign: 'right'
  },
  percentCell: {
    width: '8%',
    padding: 4,
    fontSize: 8,
    color: '#374151',
    textAlign: 'right'
  },
  commentsCell: {
    width: '20%',
    padding: 4,
    fontSize: 8,
    color: '#dc2626'
  },
  cumulativeRow: {
    backgroundColor: '#dbeafe',
    flexDirection: 'row',
    borderTop: '2px solid #1e40af'
  },
  cumulativeCell: {
    padding: 6,
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1e40af',
    textAlign: 'center'
  },
  issuesTable: {
    border: '1px solid #1e40af',
    marginBottom: 8,
    borderRadius: 4
  },
  issuesHeader: {
    backgroundColor: '#3b82f6',
    flexDirection: 'row',
    borderBottom: '1px solid #1e40af'
  },
  issuesHeaderCell: {
    padding: 6,
    fontSize: 8,
    fontWeight: 'bold',
    color: '#ffffff',
    textAlign: 'center'
  },
  issuesRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #e5e7eb'
  },
  issuesCell: {
    padding: 4,
    fontSize: 8,
    color: '#374151'
  },
  issueText: {
    color: '#dc2626'
  },
  solutionText: {
    color: '#059669'
  },
  hoursSection: {
    backgroundColor: '#f0fdf4',
    padding: 10,
    borderRadius: 6,
    border: '2px solid #16a34a',
    marginBottom: 10
  },
  hoursTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#166534',
    marginBottom: 5
  },
  hoursGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  hoursItem: {
    alignItems: 'center'
  },
  hoursValue: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#166534'
  },
  hoursLabel: {
    fontSize: 8,
    color: '#166534',
    marginTop: 2
  },
  photosSection: {
    backgroundColor: '#fef2f2',
    padding: 10,
    borderRadius: 6,
    border: '2px solid #dc2626'
  },
  photosTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#991b1b',
    marginBottom: 5
  }
});

const ProjectDetailsPDF = ({
  project = {},
  activities = [],
  additionalWorks = [],
  assignedEmployee,
  assignedWorkers = [],
  workerDetails = {},
  workingHours = {},
  hourLogDates = [],
  notificationMatrix = [],
  dueDate,
  photos = [],
}) => {
  // Calculate totals
  const percentCompleted = activities.length ? (activities.reduce((acc, a) => acc + (a.progress || 0), 0) / activities.length).toFixed(1) : '0';
  const totalWorkingHours = Object.values(workingHours).reduce((total, workerHours) => total + Object.values(workerHours).reduce((sum, h) => sum + h, 0), 0);
  const additionalHours = additionalWorks.reduce((sum, w) => sum + Number(w.hours || 0), 0);
  const totalHours = totalWorkingHours + additionalHours;
  const daysElapsed = project?.startDate ? Math.ceil((new Date() - new Date(project.startDate)) / (1000 * 60 * 60 * 24)) : 0;
  const projectDuration = project?.startDate && project?.dueDate ? Math.ceil((new Date(project.dueDate) - new Date(project.startDate)) / (1000 * 60 * 60 * 24)) : 0;
  const daysElapsedPercent = projectDuration > 0 ? ((daysElapsed / projectDuration) * 100).toFixed(1) : '0';

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>Daily Report {project?.name || 'Project'}</Text>
          <View style={styles.logoRow}>
            <Text style={styles.logo}>IES</Text>
            <Text style={styles.logo}>COMPANY</Text>
            <Text style={styles.logo}>LOGO</Text>
          </View>
          <View style={styles.separator} />
        </View>

        {/* PROJECT OVERVIEW */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Project Overview</Text>
          
          {/* General Information */}
          <View style={styles.subsection}>
            <Text style={styles.subsectionTitle}>A.1. General Information</Text>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Project Name:</Text>
              <Text style={styles.infoValue}>{project?.name || '—'}</Text>
            </View>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Status:</Text>
              <Text style={styles.infoValue}>{project?.status || '—'}</Text>
            </View>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Assigned Employee:</Text>
              <Text style={styles.infoValue}>{assignedEmployee || '—'}</Text>
            </View>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Workers Count:</Text>
              <Text style={styles.infoValue}>{assignedWorkers.length}</Text>
            </View>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Activities Count:</Text>
              <Text style={styles.infoValue}>{activities.length}</Text>
            </View>
          </View>

          {/* Overall Progress */}
          <View style={styles.progressBox}>
            <Text style={styles.progressTitle}>Overall Progress</Text>
            <Text style={styles.progressValue}>{percentCompleted}%</Text>
          </View>

          {/* Project Dates */}
          <View style={styles.subsection}>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Project Start Date:</Text>
              <Text style={styles.infoValue}>{project?.startDate ? new Date(project.startDate).toLocaleDateString('bg-BG') : '—'}</Text>
            </View>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Project Due Date:</Text>
              <Text style={styles.infoValue}>{project?.dueDate ? new Date(project.dueDate).toLocaleDateString('bg-BG') : '—'}</Text>
            </View>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Days Elapsed:</Text>
              <Text style={styles.infoValue}>{daysElapsed}</Text>
            </View>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Days Elapsed %:</Text>
              <Text style={styles.infoValue}>{daysElapsedPercent}%</Text>
            </View>
            <View style={styles.infoGrid}>
              <Text style={styles.infoLabel}>Report Date:</Text>
              <Text style={styles.infoValue}>{new Date().toLocaleDateString('bg-BG')}</Text>
            </View>
          </View>
        </View>

        {/* RESOURCES */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Resources</Text>
          
          <View style={styles.resourcesGrid}>
            {/* Direct Manpower */}
            <View style={styles.resourceTable}>
              <Text style={styles.subsectionTitle}>B.1. Direct Manpower</Text>
              <View style={styles.table}>
                <View style={styles.tableHeader}>
                  <Text style={styles.tableHeaderCell}>Work Description</Text>
                  <Text style={styles.tableHeaderCell}>No.</Text>
                </View>
                <View style={styles.tableRow}>
                  <Text style={styles.tableCell}>Assigned Workers</Text>
                  <Text style={styles.tableCell}>{assignedWorkers.length}</Text>
                </View>
                {assignedEmployee && (
                  <View style={styles.tableRowAlt}>
                    <Text style={styles.tableCell}>Assigned Employee</Text>
                    <Text style={styles.tableCell}>1</Text>
                  </View>
                )}
                <View style={styles.totalRow}>
                  <Text style={styles.tableCell}>Total Direct</Text>
                  <Text style={styles.tableCell}>{assignedWorkers.length + (assignedEmployee ? 1 : 0)}</Text>
                </View>
              </View>
            </View>

            {/* Worker Details */}
            <View style={styles.resourceTable}>
              <Text style={styles.subsectionTitle}>B.2. Worker Details</Text>
              <View style={styles.table}>
                <View style={styles.tableHeader}>
                  <Text style={styles.tableHeaderCell}>Worker Name</Text>
                  <Text style={styles.tableHeaderCell}>ID</Text>
                </View>
                {assignedWorkers.map((workerId, idx) => (
                  <View key={workerId} style={idx % 2 === 0 ? styles.tableRow : styles.tableRowAlt}>
                    <Text style={styles.tableCell}>{workerDetails[workerId]?.name || 'Unknown'}</Text>
                    <Text style={styles.tableCell}>{workerId}</Text>
                  </View>
                ))}
                {assignedWorkers.length === 0 && (
                  <View style={styles.tableRow}>
                    <Text style={styles.tableCell}>No workers assigned</Text>
                    <Text style={styles.tableCell}>—</Text>
                  </View>
                )}
              </View>
            </View>
          </View>
        </View>

        {/* WORK PERFORMANCE */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Work Performance</Text>

          {/* Activities Table */}
          <View style={styles.workTable}>
            <View style={styles.workTableHeader}>
              <Text style={[styles.workTableHeaderCell, styles.locationCell]}>Location</Text>
              <Text style={[styles.workTableHeaderCell, styles.activityCell]}>Work Accomplished</Text>
              <Text style={[styles.workTableHeaderCell, styles.unitCell]}>Unit</Text>
              <Text style={[styles.workTableHeaderCell, styles.quantityCell]}>Planned</Text>
              <Text style={[styles.workTableHeaderCell, styles.quantityCell]}>Completed</Text>
              <Text style={[styles.workTableHeaderCell, styles.percentCell]}>Progress</Text>
              <Text style={[styles.workTableHeaderCell, styles.commentsCell]}>Comments</Text>
            </View>
            
            {activities.map((act, idx) => (
              <View key={idx} style={idx % 2 === 0 ? styles.workTableRow : styles.workTableRowAlt}>
                <Text style={styles.locationCell}>{act.location || '—'}</Text>
                <Text style={styles.activityCell}>{act.name}</Text>
                <Text style={styles.unitCell}>{act.unit || '—'}</Text>
                <Text style={styles.quantityCell}>{act.planned || '0'}</Text>
                <Text style={styles.quantityCell}>{act.completed || '0'}</Text>
                <Text style={styles.percentCell}>{act.progress ? act.progress.toFixed(1) : '0,0'}%</Text>
                <Text style={styles.commentsCell}>{act.comments || ''}</Text>
              </View>
            ))}
            
            {activities.length === 0 && (
              <View style={styles.workTableRow}>
                <Text style={styles.locationCell}>—</Text>
                <Text style={styles.activityCell}>No activities</Text>
                <Text style={styles.unitCell}>—</Text>
                <Text style={styles.quantityCell}>—</Text>
                <Text style={styles.quantityCell}>—</Text>
                <Text style={styles.percentCell}>—</Text>
                <Text style={styles.commentsCell}>—</Text>
              </View>
            )}
            
            <View style={styles.cumulativeRow}>
              <Text style={[styles.cumulativeCell, {flex: 1}]}>CUMULATIVE COMPLETITION</Text>
              <Text style={styles.cumulativeCell}>{percentCompleted}%</Text>
            </View>
          </View>
        </View>

        {/* WORKING HOURS */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Working Hours</Text>
          
          <View style={styles.hoursSection}>
            <Text style={styles.hoursTitle}>Hours Summary</Text>
            <View style={styles.hoursGrid}>
              <View style={styles.hoursItem}>
                <Text style={styles.hoursValue}>{totalWorkingHours}</Text>
                <Text style={styles.hoursLabel}>Regular Hours</Text>
              </View>
              <View style={styles.hoursItem}>
                <Text style={styles.hoursValue}>{additionalHours}</Text>
                <Text style={styles.hoursLabel}>Additional Hours</Text>
              </View>
              <View style={styles.hoursItem}>
                <Text style={styles.hoursValue}>{totalHours}</Text>
                <Text style={styles.hoursLabel}>Total Hours</Text>
              </View>
            </View>
          </View>

          {/* Working Hours Table */}
          {hourLogDates.length > 0 && (
            <View style={styles.workTable}>
              <View style={styles.workTableHeader}>
                <Text style={[styles.workTableHeaderCell, {flex: 2}]}>Worker</Text>
                {hourLogDates.slice(0, 5).map(date => (
                  <Text key={date} style={styles.workTableHeaderCell}>
                    {new Date(date).toLocaleDateString('bg-BG', { day: '2-digit', month: '2-digit' })}
                  </Text>
                ))}
                <Text style={styles.workTableHeaderCell}>Total</Text>
              </View>
              
              {assignedWorkers.map((workerId, idx) => {
                const logs = workingHours[workerId] || {};
                const total = hourLogDates.reduce((sum, date) => sum + (logs[date] || 0), 0);
                return (
                  <View key={workerId} style={idx % 2 === 0 ? styles.workTableRow : styles.workTableRowAlt}>
                    <Text style={[styles.workTableCell, {flex: 2}]}>{workerDetails[workerId]?.name || 'Unknown'}</Text>
                    {hourLogDates.slice(0, 5).map(date => (
                      <Text key={date} style={styles.workTableCell}>{logs[date] ?? 0}</Text>
                    ))}
                    <Text style={styles.workTableCell}>{total}</Text>
                  </View>
                );
              })}
            </View>
          )}
        </View>

        {/* ADDITIONAL WORKS */}
        {additionalWorks.length > 0 && (
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Additional Works</Text>
            
            <View style={styles.workTable}>
              <View style={styles.workTableHeader}>
                <Text style={[styles.workTableHeaderCell, {flex: 2}]}>Description</Text>
                <Text style={styles.workTableHeaderCell}>Unit</Text>
                <Text style={styles.workTableHeaderCell}>Hours</Text>
                <Text style={styles.workTableHeaderCell}>Comments</Text>
              </View>
              
              {additionalWorks.map((work, idx) => (
                <View key={idx} style={idx % 2 === 0 ? styles.workTableRow : styles.workTableRowAlt}>
                  <Text style={[styles.workTableCell, {flex: 2}]}>{work.title || work.description || '—'}</Text>
                  <Text style={styles.workTableCell}>MH</Text>
                  <Text style={styles.workTableCell}>{work.hours || '0'}</Text>
                  <Text style={styles.workTableCell}>{work.comment || '—'}</Text>
                </View>
              ))}
            </View>
          </View>
        )}

        {/* PHOTOS */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Photos</Text>
          
          <View style={styles.photosSection}>
            <Text style={styles.photosTitle}>Project Photos ({photos.length})</Text>
            {photos.length > 0 ? (
              <View style={{marginTop: 5}}>
                {photos.slice(0, 5).map((photo, idx) => (
                  <Text key={idx} style={{fontSize: 8, marginBottom: 2, color: '#991b1b'}}>• {photo.split('/').pop()}</Text>
                ))}
                {photos.length > 5 && <Text style={{fontSize: 8, color: '#991b1b'}}>...and {photos.length - 5} more photos</Text>}
              </View>
            ) : (
              <Text style={{fontSize: 8, color: '#991b1b'}}>No photos available</Text>
            )}
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default ProjectDetailsPDF;